// ROVYX — scripts propios del tema (vanilla, sin librerías)
function mtInit() {
  initReveal();
  initContadores();
  initGaleriaProducto();
  initSelectorVariantes();
  initHeaderScroll();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mtInit);
} else {
  mtInit();
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { obs.observe(el); });

  // Red de seguridad: si el navegador no llega a disparar el observer a
  // tiempo (pestaña en segundo plano, casos raros de compositing), el
  // contenido no debe quedar invisible para siempre.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }, 2000);
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var animado = new WeakSet();
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || animado.has(entry.target)) return;
      animado.add(entry.target);
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var prog = Math.min((ts - inicio) / dur, 1);
        var val = fin * (1 - Math.pow(1 - prog, 3));
        el.textContent = (fin % 1 === 0) ? Math.round(val) : val.toFixed(1);
        if (prog < 1) requestAnimationFrame(paso);
        else el.textContent = fin % 1 === 0 ? fin : fin.toFixed(1);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src) return;
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = src;
        principal.style.opacity = '1';
      }, 150);
      minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
      mini.classList.add('mt-mini-activa');
    });
  });
}

function initSelectorVariantes() {
  var wrap = document.querySelector('[data-mt-variantes]');
  if (!wrap) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = wrap.querySelectorAll('[data-mt-opcion]');
  var inputId = document.querySelector('[data-mt-variant-id]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-compare]');
  var botonEl = document.querySelector('[data-mt-add-boton]');
  var principal = document.querySelector('[data-mt-galeria-principal]');

  wrap.querySelectorAll('.mt-producto__opcion').forEach(function (grupo) {
    var select = grupo.querySelector('[data-mt-opcion]');
    var etiquetaValor = grupo.querySelector('[data-mt-opcion-valor]');
    var botones = grupo.querySelectorAll('[data-mt-swatch]');
    if (!select || !botones.length) return;
    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        select.value = btn.getAttribute('data-value');
        botones.forEach(function (b) { b.classList.remove('mt-swatch--activa', 'mt-pill--activa'); });
        btn.classList.add(btn.classList.contains('mt-swatch') ? 'mt-swatch--activa' : 'mt-pill--activa');
        if (etiquetaValor) etiquetaValor.textContent = btn.getAttribute('data-value');
        select.dispatchEvent(new Event('change'));
      });
    });
  });

  function moneda(centavos) {
    return Shopify && Shopify.formatMoney
      ? Shopify.formatMoney(centavos, window.mtMoneyFormat || '${{amount}}')
      : '' + (centavos / 100).toFixed(2);
  }

  function actualizar() {
    var seleccion = [];
    selects.forEach(function (s) { seleccion.push(s.value); });
    var encontrada = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!encontrada) return;
    if (inputId) inputId.value = encontrada.id;
    if (precioEl) precioEl.textContent = moneda(encontrada.price);
    if (principal && encontrada.image) {
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = encontrada.image;
        principal.style.opacity = '1';
      }, 150);
    }
    if (precioCompareEl) {
      if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
        precioCompareEl.textContent = moneda(encontrada.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      if (encontrada.available) {
        botonEl.disabled = false;
        botonEl.dataset.textoOriginal = botonEl.dataset.textoOriginal || botonEl.textContent;
        botonEl.textContent = botonEl.dataset.textoAdd || botonEl.dataset.textoOriginal;
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.dataset.textoAgotado || 'Agotado';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initHeaderScroll() {
  var header = document.querySelector('.shopify-section-header, #shopify-section-header, .header-wrapper');
  if (!header) return;
  var ultimo = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY || 0;
    if (y > 30 && ultimo <= 30) header.classList.add('mt-header-scrolled');
    else if (y <= 30 && ultimo > 30) header.classList.remove('mt-header-scrolled');
    ultimo = y;
  }, { passive: true });
}
